export default "__VITE_ASSET__fc9e86d6__"